export default "__VITE_ASSET__DJKP7E6S__"